interface IAvisGridProps {
  children: React.ReactNode;
}
export function AvisGrid(props: Readonly<IAvisGridProps>) {
  const { children } = props;

  return <div className="avis-grid grid">{children}</div>;
}
